import { Divider, Stack } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppContext } from '../../providers/AppProvider/AppProvider'
import { OutlinedBox } from '../SharedUI'
import { DateSelect } from '../SharedUI/DateSelect'
import { TimeClockProductivityCard } from '../TimeClockCard/TimeClockProductivityCard'
import { TimeClockTable } from './TimeClockTable'

export const TimeClockUserDetail = () => {
  const { id } = useParams()
  const { employees } = useContext(AppContext)
  const employee = employees?.find((e) => e.userProfile!.id === id)
  const [date, setDate] = useState<Dayjs | null>(dayjs().startOf('day'))
  return employee ? (
    <OutlinedBox
      title={`Productivity Journal - ${employee.userProfile!.name!}`}
      noPadding={true}>
      <Stack spacing={1}>
        <TimeClockProductivityCard employeeId={employee.userProfile!.id!} />
        <Divider />
        <Stack alignItems={'flex-end'} p={1}>
          <DateSelect {...{ date, setDate }} label="Start Time" />
        </Stack>
        <Divider />
        <TimeClockTable {...{ date, employee }} />
      </Stack>
    </OutlinedBox>
  ) : (
    <></>
  )
}
